<div class="background">
  <h3 *ngIf="data.title">{{ data.title }}</h3>
  <p *ngIf="data.message">{{ data.message }}</p>

  <div [align]="'end'" mat-dialog-actions>
    <button [mat-dialog-close]="false" mat-button>
      {{ data.cancelButtonText || "Cancel" }}
    </button>
    <button
      [mat-dialog-close]="true"
      cdkFocusInitial
      mat-button
      color="primary"
    >
      {{ data.confirmButtonText || "Confirm" }}
    </button>
  </div>
</div>
